export const DEFAULT_SETTINGS = {
  canRegister: true,
  canExternalProviders: true,
  canRemember: true,
  adminLogin: false
};

export const SETTINGS = {
  "visary-ui": {
    canRegister: false,
    canExternalProviders: false,
    adminLogin: true
  },
  "lk-smena": {}
};

export const createSettings = clientId =>
  ({ ...DEFAULT_SETTINGS, ...SETTINGS[clientId] });
